import { routes } from "pages/routes";
import bookImg from "./../../../../../images/book.svg";
import { Link } from "react-router-dom";
import { FC } from "react";
import type { ObjectCardObject } from "../ObjectCard/ObjectCard";

interface IFolderCard {
  object: ObjectCardObject;
}

const FolderCard: FC<IFolderCard> = props => {
  const image =
    props.object.preview_horizontal_url ?? props.object.preview_url ?? bookImg;
  const objectId = props.object.id;

  const card = (
    <div className="folder-card">
      <div className="img-container">
        <img src={image} alt="preview" className="preview-img" />
      </div>
      <div className="folder-card-title">{props.object.name}</div>
    </div>
  );

  return (
    <div className="folder-card-wrapper">
      {objectId === undefined ? (
        // The folder dialog previews an object that does not exist yet, so there
        // is nothing to link to. Same case as ObjectCard.
        card
      ) : (
        <Link to={routes.libraryObject.path({ id: objectId })}>{card}</Link>
      )}
    </div>
  );
};

export default FolderCard;
